import React from 'react';
import { Utensils, Award, Heart } from 'lucide-react';
import './About.css';

const About = () => {
  return (
    <section id="about" className="about-section">
      <div className="about-container">
        <div className="about-header animate-fade-in-up">
          <h2 className="section-title">Our Story</h2>
          <div className="title-divider"></div>
        </div>

        <div className="about-content">
          <div className="about-text animate-fade-in-up">
            <p className="about-description">
              Welcome to Kothu Rotti, Glasgow's premier destination for authentic Sri Lankan and South Indian cuisine. 
              Our journey began with a passion for bringing the vibrant, spicy aromas and rich flavors of traditional 
              Tamil cooking to the heart of Scotland.
            </p>
            <p className="about-description">
              Every dish we serve is crafted with love, using time-honored recipes passed down through generations. 
              From our signature Kothu Rotti to our aromatic curries, each plate tells a story of heritage, 
              authenticity, and culinary excellence.
            </p>
          </div>

          <div className="about-features">
            <div className="feature-card hover-lift">
              <div className="feature-icon">
                <Utensils size={32} />
              </div>
              <h3 className="feature-title">Authentic Cuisine</h3>
              <p className="feature-description">
                Traditional Sri Lankan and South Indian recipes prepared with authentic spices and techniques
              </p>
            </div>

            <div className="feature-card hover-lift">
              <div className="feature-icon">
                <Award size={32} />
              </div>
              <h3 className="feature-title">Premium Quality</h3>
              <p className="feature-description">
                Fresh ingredients and highest quality standards in every dish we serve
              </p>
            </div>

            <div className="feature-card hover-lift">
              <div className="feature-icon">
                <Heart size={32} />
              </div>
              <h3 className="feature-title">Made with Love</h3>
              <p className="feature-description">
                Every plate is prepared with passion and care by our experienced chefs
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;